import { AxiosInstance } from 'axios';

import { ServiceBaseConfig } from './Interfaces/IAccountService';
import { GetDataOnboarding, SaveDataOnboardingPayload } from './Interfaces/IOnboardingService';

export class OnboardingService {
  public static async saveDataOnboarding(
    api: AxiosInstance,
    payload: SaveDataOnboardingPayload,
    config: ServiceBaseConfig
  ): Promise<GetDataOnboarding> {
    const { data } = await api.post('plan/onboarding-json', payload, config);

    return data;
  }

  public static async putPreviousOnboardingStep(
    api: AxiosInstance,
    config: ServiceBaseConfig
  ): Promise<GetDataOnboarding> {
    const { data } = await api.put('plan/onboarding-json/previous-step', {}, config);

    return data;
  }
  public static async getDataOnboarding(api: AxiosInstance, config: ServiceBaseConfig): Promise<GetDataOnboarding> {
    const { data } = await api.get('plan/onboarding-json', config);

    return data;
  }

  public static async resetOnboarding(api: AxiosInstance, config: ServiceBaseConfig): Promise<void> {
    await api.delete('plan/onboarding-json', config);
  }
}
